import { useCallback, useEffect, useState } from 'react'
import { useEffectOnce, useWindowSize } from 'usehooks-ts'
import { useLocalStorage } from 'usehooks-ts'
import styled from 'styled-components'

const Chapter = ({ data, bg }: { data?: any; bg: string }) => {
  const [birthYear, setBirthYear] = useLocalStorage('birthYear', -1)
  const [avatarId, setAvatarId] = useLocalStorage('avatarId', -1)
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
  }

  useEffect(() => {
    // an eventlistener on the window object that listens for the event 'userBirthyear' and calls the function onHandleBirthyear
    window.addEventListener('userBirthyear', onHandleBirthyear)
    return () => {
      window.removeEventListener('userBirthyear', onHandleBirthyear)
    }
  }, [])

  // the function that is called when the event 'userBirthyear' is fired
  const onHandleBirthyear: any = useCallback((event: CustomEvent) => {
    setBirthYear(event.detail)
  }, [])

  const { width } = useWindowSize()
  const [height, setHeight] = useState(0)
  useEffectOnce(() => {
    setHeight(window.innerHeight)
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <>
      {birthYear > 0 && (
        <ChaptersWrapper className={bg}>
          <Head>
            <div className='video-auto-play' style={{ position: 'relative' }}>
              <Sectiontitle>
                <span
                  dangerouslySetInnerHTML={{
                    __html: isMobile ? data.titleMobile : data.title,
                  }}
                />
              </Sectiontitle>
              <video playsInline autoPlay loop muted>
                <source src={data.video} type='video/mp4' />
              </video>
              <div className='source'>
                <span
                  dangerouslySetInnerHTML={{
                    __html: data.source,
                  }}
                />
                <div className='license'>{data.license}</div>
              </div>
            </div>
            <div>{data.intro}</div>
          </Head>
          <Grid>
            {data.content.map((element: any, index: number) => {
              let persContent: any = {}

              if (element.type === 'personalized') {
                persContent = element.text.filter(
                  (el: any) => el.from <= birthYear && el.to >= birthYear
                )
              }
              return element.type === 'personalized' ? (
                <Section id='1-2'>
                  <div className='personalized'>
                    <div className='avatar-wrapper'>
                      <img
                        className='avatar'
                        alt='avatar'
                        src={require('../../images/avatar/' +
                          avatarId +
                          '.png')}
                      />
                      <div className='year'>{birthYear}</div>
                    </div>
                    <h4>{persContent[0].title}</h4>
                    {persContent[0].txt}
                  </div>
                </Section>
              ) : (
                <Section className='general' id={index + '-'}>
                  {element.text}
                </Section>
              )
            })}
          </Grid>
        </ChaptersWrapper>
      )}
    </>
  )
}

const ChaptersWrapper = styled.div`
  overflow: hidden;
  padding: 6rem 0 4rem;
  @media only screen and (max-width: 711px) {
    padding-top: 0;
  }
  text-align: left;
  color-scheme: dark;
  color: #fff;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  font-family: var(--font-sans-serif);
  img {
    max-width: 100%;
  }
  &.high {
    margin-top: 300px;
  }
  .personalized {
    background-color: #3a3730;
    border-radius: 4px;
    padding: 2rem 3rem 1rem;
    font-size: 1.7rem;
    line-height: 2.8rem;
    @media only screen and (max-width: 1400px) {
      margin-left: 4rem;
      margin-right: 4rem;
    }
    @media only screen and (max-width: 711px) {
      padding: 2rem 1.5rem 1rem;
      margin-left: 10px;
      margin-right: 10px;
    }
    h4 {
      font-size: 2rem;
      line-height: 2.8rem;
      text-align: center;
      max-width: 300px;
      margin: 0 auto 2rem;
    }
    .avatar-wrapper {
      text-align: center;
      .avatar {
        width: 6%;
        @media only screen and (max-width: 711px) {
          width: 10%;
        }
        margin: 0 auto;
      }
      .year {
        font-size: 1.2rem;
      }
    }
  }
  .general {
    font-family: var(--font-serif);
    @media only screen and (min-width: 712px) {
      font-size: 1.9rem;
      line-height: 3.3rem;
    }
    @media only screen and (max-width: 1400px) {
      padding-left: 4rem;
      padding-right: 4rem;
    }
    @media only screen and (max-width: 711px) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  &.dark {
    background-color: rgba(0, 0, 0, 0.4);
  }
`

const Section = styled.div`
  margin: 0 auto 4rem;
  @media only screen and (min-width: 1400px) {
    margin: 0;
  }
  color: #fff;
  max-width: 780px;
`

const Grid = styled.div`
  @media only screen and (min-width: 1400px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    max-width: 1340px;
    margin: 0 auto;
  }
`

const Head = styled.div`
  position: relative;
  width: 100%;
  text-align: center;
  color: #fff;
  margin-bottom: 2rem;

  @media only screen and (max-width: 711px) {
    /* width: 118%;
    margin-left: -9%; */
    max-width: 100vw;
    margin-left: -2rem;
    max-width: calc(100% + 4rem);
    width: calc(100% + 4rem);
  }

  video {
    width: 720px;
    border-radius: 10px;
    @media only screen and (max-width: 711px) {
      width: 120%;
      max-width: 120%;
      border-radius: 0;
    }
  }
  .source {
    width: 40%;
    max-width: 720px;
    @media only screen and (max-width: 711px) {
      width: 90%;
    }
    margin: 0.3rem auto;
    padding: 0 1rem;
    text-align: left;
    font-size: 1.3rem;
    line-height: 1.8rem;
    @media only screen and (max-width: 711px) {
      font-size: 1.1rem;
      line-height: 1.6rem;
    }
    color: var(--gray-3);
    .license {
      color: var(--gray-2);
    }
    a {
      color: rgb(108, 170, 240) !important;
      background-image: none !important;
    }
  }

  .intro {
    text-align: left;
    max-width: 720px;
    padding: 0 1rem;
    margin: 2rem auto 10rem;
    @media only screen and (max-width: 711px) {
      width: 90%;
      margin-bottom: 4rem;
    }
    @media only screen and (min-width: 712px) {
      text-align: center;
      width: 80%;
      font-size: 1.9rem;
      line-height: 3.3rem;
    }
  }
`

const Sectiontitle = styled.h2`
   {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    bottom: 8rem;
    span {
      background-color: rgba(0, 0, 0, 0.75);
      padding: 0.5rem 2rem;
      -webkit-box-decoration-break: clone;
      box-decoration-break: clone;
    }
    font-family: 'Suez One', serif;
    font-weight: 100;
    font-size: 5rem;
    line-height: 7.75rem;
    text-align: center;
    @media only screen and (max-width: 711px) {
      font-size: 3.5rem;
      line-height: 5.8rem;
      max-width: 90%;
      margin: 0 auto;
    }
  }
`

export default Chapter
